import i, { useRef as s, useEffect as c } from "react";
import { cls as b } from "../../../../helpers/cls.js";
const o = _ref => {
  let {
    id: a,
    children: d,
    selected: e
  } = _ref;
  const n = s(null);
  return c(() => {
    var r;
    const t = (r = n.current) == null ? void 0 : r.querySelectorAll("a");
    return e ? t == null ? void 0 : t.forEach(l => l.setAttribute("tabindex", "0")) : t == null ? void 0 : t.forEach(l => l.setAttribute("tabindex", "-1"));
  }, [e]), i.createElement("div", {
    className: b("olx-tabs__tabpanel", e && "olx-tabs__tabpanel--selected"),
    "data-ds-component": "DS-TabPanel",
    id: "panel-".concat(a),
    role: "tabpanel",
    "aria-labelledby": a,
    "aria-hidden": !e,
    ref: n
  }, d);
};
o.displayName = "TabPanel";
export { o as TabPanel };